/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/194-cloud': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 10.274a2.726 2.726 0 00-2.078-2.648A3.72 3.72 0 0010.205 4a3.712 3.712 0 00-2.92 1.418 2.09 2.09 0 00-3.719 1.573 3.028 3.028 0 00-3.567 2.98A3.028 3.028 0 003.026 13H13.28a2.725 2.725 0 002.719-2.726z"/>'
  }
})
